import * as React from 'react';
import { IListViewColumn } from "../../../../../services/ViewService";
import { Resource } from "../../../../../store/ResourcesListStore";
import EntityName from '../EntityName';

export default class Calendar extends React.Component<IListViewColumn<Resource>> {
    public render() {
        const { entity, isTimelineView } = this.props;
        const calendarInfo = entity.calendar;
        if (!calendarInfo) {
            return null;
        }

        return <div className="icons-box">
            <EntityName
                key={calendarInfo.id}
                name={calendarInfo.name}
                isTimelineView={isTimelineView}
                url={`/calendar/${calendarInfo.id}`}
                imageClassName='calendar-logo'
            />
        </div>;
    }

    public static getValue(entity: Resource): string | undefined {
        return entity.calendar?.name;
    }

    public static getSearchValue(entity: Resource): string | undefined {
        return entity.calendar?.name;
    }
}
